<template>
  <div :class="divClassName ? divClassName : ''">
    <span v-if="isTikTok"><img src="/static/img/tiktok-32.png" width="20px" /> @{{tiktokHandle}}</span>
    <span v-if="isInstagram"><v-icon class="social-handle-view__instagram" color="#E1306C" small>mdi-instagram</v-icon> @{{instagramHandle}}</span>
    <span v-if="isFacebook"><v-icon class="social-handle-view__facebook" color="#1877F2" small>mdi-facebook</v-icon> @{{facebookHandle}}</span>
    <span v-if="isLinkedIn"><v-icon class="social-handle-view__linkedin" color="#0A66C2" small>mdi-linkedin</v-icon> @{{linkedinHandle}}</span>
    <span v-if="isTwitter"><img src="/static/img/x-logo.svg" width="15px" alt="" aria-hidden="true" /> @{{twitterHandle}}</span>
    <span v-if="isYoutube"><v-icon class="social-handle-view__youtube" color="#FF0000" small>mdi-youtube</v-icon> @{{youtubeHandle}}</span>
    <span v-if="isXiaohongshu"><img src="/static/img/xhs-black.png" width="15px" style="border-radius:15%" /> {{xiaohongshuFullName || xiaohongshuHandle}}</span>
    <span v-if="isOthers"><v-icon color="#000000" small>mdi-help-circle</v-icon> {{otherHandle}}</span>
    <span v-if="!hasExplicitPlatform && otherHandle"><img src="/static/img/x-logo.svg" width="15px" alt="X" /> @{{otherHandle}}</span>
  </div>
</template>
<script>
  export default {
    name: 'SocialHandle',
    props: [
      'isTikTok',
      'isInstagram',
      'isFacebook',
      'isLinkedIn',
      'isTwitter',
      'tiktokHandle',
      'instagramHandle',
      'facebookHandle',
      'linkedinHandle',
      'twitterHandle',
      'divClassName',
      'isYoutube',
      'youtubeHandle',
      'youtubeURL',
      'isXiaohongshu',
      'xiaohongshuHandle',
      'xiaohongshuFullName',
      'isOthers',
      'otherHandle'
    ],
    computed: {
      hasExplicitPlatform() {
        return this.isTikTok || this.isInstagram || this.isFacebook || this.isLinkedIn || this.isTwitter || this.isYoutube || this.isXiaohongshu || this.isOthers
      }
    },
    methods: {
      showYoutubeURL(youtubeURL) {
        if (youtubeURL && youtubeURL.includes('https://www.youtube.com')) {
          return youtubeURL
        } else {
          return 'https://youtube.com/@' + this.youtubeHandle
        }
      },
      openLink(link) {
        window.open(link, '_blank')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SocialHandleView.vue?40af04cc